import { pdd } from '../data/pdd'

export const Laws = () => {
  return <div>{pdd.part1.text}</div>
}
